<template>
    <div>
        <div class="hero_banner">
            <div class="container">
                <!-- <router-link :to="{ name: 'Home' }" class="hero_logo_wrapper">
                    <img class="hero_logo" src="~@/assets/Logo text.svg" alt="Boolland Logo">
                </router-link> -->
                <a href="mailto:engage@boolland.com" class="hero_logo_wrapper">
                    <img class="hero_logo" src="~@/assets/Logo text.svg" alt="Boolland Logo">
                </a>
                <div class="hero_text_wrapper">
                    <h1 class="title">
                        Busy building amazing websites for clients! <br>Our own portfolio will be updated later.
                    </h1>
                    <h3 class="subtitle">To view our work, visit our clients' websites instead.</h3>
                </div>
            </div>
        </div>
        <div class="project_wrapper container d-flex">
            <a class="project_box" v-for="project in projects" :key="project.name" :title="project.name"
                :href="project.url" target="_blank">
                <img :src="project.logo_url" :alt="project.name" />
            </a>
        </div>
        <div class="contact_us_marquee" @mouseover="togglePause(true)" @mouseleave="togglePause(false)">
            <vue-marquee-slider id="contact_us_slider" :class="testing" :speed="5000" :paused="isPaused" :space="0" :repeat="30" :width="450" >
                <div class="marquee_item">
                    <div class="h3 marquee_text">Let's talk</div>
                    <router-link :to="{ name: 'Calendly' }" class="marquee_button btn">Book Time</router-link>                    
                </div>
            </vue-marquee-slider>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            projects: [
                {
                  name: 'ZUS Coffee',
                  url: 'https://shop.zuscoffee.com/',
                  logo_url: require('@/assets/images/project_logo/zus_logo.png')            
                },
                {
                    name: 'Montigo',
                    url: 'http://shopmontigo.com/',
                    logo_url: require('@/assets/images/project_logo/Montigo_logo.png')
                },
                {
                    name: 'OIYO',
                    url: 'https://www.oiyoshop.com/',
                    logo_url: require('@/assets/images/project_logo/OIYO_logo.png')
                },
                {
                    name: 'Over Bottle',
                    url: 'https://overmalaysia.com/',
                    logo_url: require('@/assets/images/project_logo/OverMalaysia_logo.png')
                },
                {
                    name: 'Caketella',
                    url: 'https://www.caketella.com/',
                    logo_url: require('@/assets/images/project_logo/Caketella_logo.png')
                },
                {
                    name: 'Nature\'s Comeback',
                    url: 'https://www.natures-comeback.com/',
                    logo_url: require('@/assets/images/project_logo/Nature_Comeback_Logo.png')
                },
                {
                    name: 'Fiskor',
                    url: 'https://www.fiskor.co/',
                    logo_url: require('@/assets/images/project_logo/Fiskor_logo.png')
                },
                {
                    name: 'HYGR',
                    url: 'https://hygr.my/',
                    logo_url: require('@/assets/images/project_logo/HYGR_logo.png')
                },
                {
                    name: 'Russell Taylors',
                    url: 'https://www.russelltaylors.co.uk/',
                    logo_url: require('@/assets/images/project_logo/RussellTaylors_logo.png')            
                },
                {
                    name: 'SupermamaLab',
                    url: 'https://www.supermamalab.com.my/',
                    logo_url: require('@/assets/images/project_logo/Supermamalab_logo.png')
                },
                {
                    name: 'Dayang Ros',
                    url: 'https://www.dayangros.com/',
                    logo_url: require('@/assets/images/project_logo/DayangRos_Logo.png')
                },
                {
                    name: 'Zucca',
                    url: 'https://www.shopzucca.com/',
                    logo_url: require('@/assets/images/project_logo/ZUCCA_logo.png')
                },
                {
                    name: 'Ventamin',
                    url: 'https://ventamin.com/',
                    logo_url: require('@/assets/images/project_logo/Ventamin_logo.png')            
                },                                                               
                {
                    name: 'Aemis',
                    url: 'https://aemis.store/',
                    logo_url: require('@/assets/images/project_logo/Aemis_logo.png')
                },       
                {
                    name: 'Femoire',
                    url: 'https://femoire.com/',
                    logo_url: require('@/assets/images/project_logo/Femoire_logo.png')
                },       
                {
                    name: 'Spectrum Health',
                    url: 'https://spectrumhealth.com.my/',
                    logo_url: require('@/assets/images/project_logo/SpectrumHealth_Logo.png')
                },       
                {
                    name: 'Vitera',
                    url: 'https://myvitera.com/',
                    logo_url: require('@/assets/images/project_logo/Vitera_Logo.png')
                },       
                {
                    name: 'Kintry',
                    url: 'https://kintry.co/',
                    logo_url: require('@/assets/images/project_logo/Kintry_logo.png')
                },       
                {
                    name: 'Hoppi',
                    url: 'https://www.heyhoppi.com.my/',
                    logo_url: require('@/assets/images/project_logo/Hoppi_logo.png')
                },
                {
                    name: 'SWAN Bag',
                    url: 'https://swanbag.com/',
                    logo_url: require('@/assets/images/project_logo/SWAN_Logo.png')
                },      
                {
                    name: 'Nihon Skin',
                    url: 'https://nihonskin.com/',
                    logo_url: require('@/assets/images/project_logo/NihonSkin_logo.png')            
                },                                 
                {
                    name: 'ByThian',
                    url: 'https://bythian.my/',
                    logo_url: require('@/assets/images/project_logo/Bythian_logo.png')
                },
                {
                    name: 'Artelia',
                    url: 'https://artelia.com.my/',
                    logo_url: require('@/assets/images/project_logo/Artelia_Logo.png')
                },                                
                {
                    name: 'Mikosa Jewellery',
                    url: 'https://www.mikosajewellery.com/',
                    logo_url: require('@/assets/images/project_logo/MIKOSA_LOGO_BLACK.png')
                },                                
                {
                    name: 'Casebang MY',
                    url: 'https://www.shopcasebang.com.my/',
                    logo_url: require('@/assets/images/project_logo/Casebang_logo.png')
                },      
                {
                    name: 'Heralabel',
                    url: 'https://heralabel.co/',
                    logo_url: require('@/assets/images/project_logo/Hera_logo.png')
                },                                                                      
                {
                    name: 'Deskbird',
                    url: 'https://www.deskbird.co.nz/',
                    logo_url: require('@/assets/images/project_logo/deskbird_logo.png')
                },
                {
                    name: 'Nestbloom',
                    url: 'https://nestbloom.com.my/',
                    logo_url: require('@/assets/images/project_logo/NestBloom_Logo.png')
                },
                {
                    name: 'Geo Coloured Lenses',
                    url: 'https://geocolouredlenses.com/',
                    logo_url: require('@/assets/images/project_logo/GeoColouredLens_logo.png')
                },             
                {
                    name: 'Alcean',
                    url: 'https://alcean.com/pages/alcean',
                    logo_url: require('@/assets/images/project_logo/Alcean_logo.png')
                },
                {
                    name: 'Thong Kee',
                    url: 'https://thongkee.com/',
                    logo_url: require('@/assets/images/project_logo/Thongkee_Logo.png')
                },   
                {
                    name: 'Kyut Skin',
                    url: 'https://kyutskin.com/',
                    logo_url: require('@/assets/images/project_logo/Kyutskin_logo.png')
                },
                {
                    name: 'Salang Design',
                    url: 'https://salangdesign.com/',
                    logo_url: require('@/assets/images/project_logo/Salang_logo.png')
                },                               
                {
                    name: 'Preface',
                    url: 'https://prefaceskin.com/',
                    logo_url: require('@/assets/images/project_logo/Preface_logo.png')
                },
                {
                    name: 'Complement',
                    url: 'https://complementcandles.com/',
                    logo_url: require('@/assets/images/project_logo/Complement_logo.png')
                },
                {
                    name: 'Mates',
                    url: 'https://my.matesfood.co/',
                    logo_url: require('@/assets/images/project_logo/Mates_logo.png')
                },
                {
                    name: 'Titan Autohaus',
                    url: 'https://www.titanautohaus.com/',
                    logo_url: require('@/assets/images/project_logo/TitanAutohaus_logo.png')
                }                      
                // {
                //     name: 'OCDEE',
                //     url: 'https://ocdee.co/',
                //     logo_url: require('@/assets/images/project_logo/Ocdee_logo.png')
                // },             
                // {
                //   name: 'Keyyes',
                //   url: 'https://keyyes.co/',
                //   logo_url: require('@/assets/images/project_logo/Keyyes_logo.png')            
                // }, 
                // {
                //     name: 'Jin Yuan',
                //     url: 'https://www.jinyuan.com.my/',
                //     logo_url: require('@/assets/images/project_logo/JinYuan_logo.png')
                // },                
                // {
                //     name: 'Respi Theory',
                //     url: 'https://www.respitheory.com/',
                //     logo_url: require('@/assets/images/project_logo/Respitheory_logo.png')
                // },                
                // {
                //     name: 'LAX',
                //     url: 'https://heylax.com/',
                //     logo_url: require('@/assets/images/project_logo/Lax_logo.png')
                // },
                // {
                //     name: 'SKG Malaysia',
                //     url: 'https://skgmalaysia.com/',
                //     logo_url: require('@/assets/images/project_logo/SKG_logo.png')
                // }
            ],
            isPaused: false
        }
    },
    methods: {
        togglePause(playPause) {
            this.isPaused = playPause
        }
    },
}

</script>

<style lang="scss" scoped>
.hero_banner {
    padding: 100px 30px 150px;
    background-color: #3645d3;
    font-family: "Plus Jakarta Sans";

    @media (width < 767px) {
        & {
            padding-top: 48px;
            padding-bottom: 48px;
        }
    }

    .hero_logo_wrapper {
        display: block;
        width: fit-content;
        margin-bottom: 80px;

        @media (width < 767px) {
            & {
                margin-bottom: 48px;
            }
        }

        .hero_logo {
            max-width: 200px;
            width: 100%;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 8px 8px 16px #323fc2, -8px -8px 16px #3a4be4;

            @media (width < 767px) {
                & {
                    max-width: 140px;
                }
            }
        }
    }

    .hero_text_wrapper {
        color: #D8D8D8;
        max-inline-size: 60ch;
        text-wrap: balance;

        .title {
            margin-bottom: 48px;
            font-size: 60px;
            font-weight: bold;
        }

        .subtitle {
            font-size: 20px;
        }

        @media (width < 767px) {
            .title {
                font-size: 36px;
            }

            .subtitle {
                font-size: 18px;
            }
        }
    }
}

.project_wrapper {
    padding-top: 48px;
    padding-bottom: 48px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    font-family: "Plus Jakarta Sans";

    @media (width < 767px) {
        & {
            gap: 20px;
        }
    }

    .project_box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        width: 120px;
        height: 120px;
        border-radius: 60px;
        box-shadow: 8px 8px 16px #e0e0e0, -8px -8px 16px #ffffff;
        transition: all 0.2s ease;
        object-fit: contain;
        overflow: hidden;

        @media (width < 576px) {
            & {
                width: 100px;
                height: 100px;
            }
        }

        &:hover {
            box-shadow: inset 8px 8px 16px #e0e0e0, inset -8px -8px 16px #ffffff;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            aspect-ratio: 2;
            pointer-events: none;

            &:hover {
                // padding:8px;
                // transform: scale(1.05);
            }
        }
    }
}
.contact_us_marquee{
    background-color: #3645d3;
    color: #D8D8D8;
    font-family: "Plus Jakarta Sans";

    #contact_us_slider{
        padding-top: 48px;
        padding-bottom: 48px;        
        .marquee_item{
            display: flex;
            flex-wrap:nowrap;
            justify-content: space-around;
            align-items: center;
            padding: 0px 48px;
            .marquee_text{
                margin-bottom: 0px;
                font-weight: bold;
                font-size: 24px;
            }
            .marquee_button{
                box-shadow: 8px 8px 16px #323fc2, -8px -8px 16px #3a4be4;
                padding: 16px 32px;
                color: #D8D8D8;
                font-size: 18px;
                font-weight: bold;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/teaser/Homepage.vue